// Vendors
import React from 'react';
import { Typography } from '@mui/material';

// Components
import ReusablePopup from '@/components/organism/PopUp/ReusablePopup/ReusablePopup';

// Store
import { POPUP_TYPES } from '@/utils/constants';
import { EventData } from '@/utils/types';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  data: EventData;
}

const AgentInfoPopup: React.FC<Props> = ({ isOpen, onClose, data }) => {
    const formatDate = (DateStr: string | null | undefined) => {
        if (!DateStr) return '';
        const date = new Date(DateStr);
        if (isNaN(date.getTime())) return '';
        return (
            `${(date.getMonth() + 1).toString().padStart(2, '0')}/` +
            `${date.getDate().toString().padStart(2, '0')}/` +
            date.getFullYear().toString()
        );
    };

    const formatPhoneNumber = (phone: string | null | undefined) => {
        if (!phone) return '';
        // Remove all non-digit characters
        const digits = phone.replace(/\D/g, '');
        if (digits.length !== 10) return phone;
        return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    };

    const formatAmount = (value: string): string => {
    if (value) {
      const clean = value.replace(/,/g, '').trim();

      const number = parseFloat(clean);
      if (isNaN(number)) return value;
    return `$${number.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
    } else return '';
  };

  return (
    <ReusablePopup
      isOpen={isOpen}
      onClose={onClose}
      typeClassName="contract-details-popup"
      type={POPUP_TYPES.AGENT_DETAILS}
      header={`Policy: ${data.policyNumber ?? ''}`}
    >
      {/* {data.effectiveDate &&  */}
      <Typography className="popup-content">Policy Effective: {formatDate(data.effectiveDate)}</Typography>
      {/* } */}
      {/* {data.expirationDate &&  */}
      <Typography className="popup-content">Policy Expiration: {formatDate(data.expirationDate)}</Typography>
      {/* } */}
       {/* {data.totalLimit &&  */}
      <Typography className="popup-content">Total Limit: {formatAmount(data.totalLimit ?? '')}</Typography>
      {/* } */}
      {/* {data.insCompany &&  */}      
      <Typography className="popup-content">Company: {data.insCompany}</Typography>
      {/* } */}
      {/* {data.agentName &&  */}
      <Typography className="popup-content">Agent Name: {data.agentName}</Typography>
      {/* } */}
      {/* {(data.agentAddress1 || data.agentAddress2) &&  */}
      <Typography className="popup-content">Agent Address: {data.agentAddress1} {data.agentAddress2}</Typography>
      {/* } */}
      {/* {(data.agentCity || data.agentState || data.agentZip) &&  */}
     <Typography className="popup-content">
        City/State/ZIP: {data.agentCity}
        {(data.agentState || data.agentZip) ? ',' : ''} {data.agentState} {data.agentZip}
     </Typography>
      {/* } */}
      {/* {(data.agentPhone) &&  */}
      <Typography className="popup-content">Agent Phone: {formatPhoneNumber(data.agentPhone)}</Typography>
      {/* } */}
      {/* {(data.agentFax) &&  */}
      <Typography className="popup-content">Agent Fax: {data.agentFax}</Typography>
      {/* } */}
      {/* {(data.agentEmail) &&  */}
      <Typography className="popup-content">Agent Email: {data.agentEmail}</Typography>
      {/* } */}
    </ReusablePopup>
  );
};

export default AgentInfoPopup;
